import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, vModelRadio as _vModelRadio, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col min-h-screen"
}
const _hoisted_2 = { class: "bg-white flex-1" }
const _hoisted_3 = {
  key: 0,
  class: "mx-auto max-w-7xl py-24 sm:px-6 sm:py-12 lg:px-8"
}
const _hoisted_4 = { class: "relative isolate px-6 py-12 text-center sm:px-16" }
const _hoisted_5 = ["textContent"]
const _hoisted_6 = ["textContent"]
const _hoisted_7 = {
  key: 0,
  class: "mt-10 flex flex-col items-center"
}
const _hoisted_8 = { class: "flex flex-col items-start sm:w-96 relative mx-auto" }
const _hoisted_9 = ["textContent"]
const _hoisted_10 = {
  key: 1,
  class: "mt-10 flex flex-col items-center"
}
const _hoisted_11 = { class: "flex flex-col items-start w-96 relative" }
const _hoisted_12 = { class: "flex flex-col items-start sm:w-96 relative mx-auto" }
const _hoisted_13 = ["textContent"]
const _hoisted_14 = {
  key: 2,
  class: "mt-10 flex items-center justify-center gap-x-6"
}
const _hoisted_15 = {
  key: 1,
  class: "overflow-hidden"
}
const _hoisted_16 = { class: "mx-auto max-w-2xl px-4 py-16 sm:px-6 sm:py-12 lg:max-w-7xl lg:px-8" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h1", { class: "text-dark-blue text-3xl text-center font-bold" }, "Select a Campaign", -1)
const _hoisted_18 = {
  key: 0,
  class: "mt-12 relative w-96"
}
const _hoisted_19 = ["textContent"]
const _hoisted_20 = {
  key: 1,
  class: "text-center mt-10"
}
const _hoisted_21 = {
  key: 0,
  class: "text-4xl text-dark-blue font-bold whitespace-nowrap"
}
const _hoisted_22 = { class: "grid grid-cols-1 gap-y-4 sm:grid-cols-2 sm:gap-x-6 sm:gap-y-10 lg:grid-cols-3 lg:gap-x-8 mt-12" }
const _hoisted_23 = { class: "aspect-h-4 aspect-w-3 bg-gray-200 sm:aspect-none sm:h-96" }
const _hoisted_24 = ["src"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "text-2xl mb-2.5 font-bold text-dark-blue" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "absolute inset-0" }, null, -1)
const _hoisted_28 = { class: "flex justify-between" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "text-base text-dark-blue mb-3" }, "End Date:", -1)
const _hoisted_30 = { class: "text-base text-orange-red" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", { class: "text-dark-blue text-lg font-bold" }, "My Story", -1)
const _hoisted_32 = { class: "text-dark-blue text-sm mt-2" }
const _hoisted_33 = {
  key: 2,
  class: "mt-6 mx-8 mb-10"
}
const _hoisted_34 = { class: "border border-gray-900/5 rounded-md shadow-sm max-w-7xl px-4 sm:px-6 sm:py-12 lg:px-8 mx-auto" }
const _hoisted_35 = { class: "flex justify-between" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("img", {
  class: "mr-1",
  src: "/img/Icons/Back_arrow.svg",
  alt: "Back"
}, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("h1", { class: "text-sm text-dark-blue" }, "Back", -1)
const _hoisted_38 = [
  _hoisted_36,
  _hoisted_37
]
const _hoisted_39 = { class: "mt-8" }
const _hoisted_40 = { class: "space-y-24" }
const _hoisted_41 = { class: "grid grid-cols-1 text-sm sm:grid-cols-12 sm:grid-rows-1 sm:gap-x-6 md:gap-x-8 lg:gap-x-8" }
const _hoisted_42 = { class: "sm:col-span-4 md:col-span-5 md:row-span-2 md:row-end-2" }
const _hoisted_43 = { class: "aspect-h-1 aspect-w-1 overflow-hidden rounded-lg bg-gray-50" }
const _hoisted_44 = ["src"]
const _hoisted_45 = {
  key: 0,
  class: "mt-6 sm:col-span-7 sm:mt-0 md:row-end-1"
}
const _hoisted_46 = { class: "text-2xl font-bold text-dark-blue" }
const _hoisted_47 = { class: "mt-2 font-medium text-gray-500" }
const _hoisted_48 = { class: "mt-1 text-gray-500" }
const _hoisted_49 = { class: "sm:col-span-12 md:col-span-7" }
const _hoisted_50 = { class: "flex my-4" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("p", { class: "text-dark-blue text-base" }, "Start Date", -1)
const _hoisted_52 = { class: "text-dark-blue text-sm mt-1.5" }
const _hoisted_53 = { class: "ml-14" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("p", { class: "text-dark-blue text-base" }, "End Date", -1)
const _hoisted_55 = { class: "text-dark-blue text-sm mt-1.5" }
const _hoisted_56 = { class: "flex mt-1" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("p", { class: "mr-2 text-lg font-medium text-dark-blue" }, "Total Funding Needed:", -1)
const _hoisted_58 = { class: "text-dark-blue text-lg" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("p", { class: "uppercase text-white text-sm sm:text-lg font-bold pl-2 flex-1" }, "Share Campaign", -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("img", {
  class: "h-10 cursor-pointer",
  src: "/img/Icons/Share_Campaign.svg",
  alt: "Share"
}, null, -1)
const _hoisted_61 = [
  _hoisted_60
]
const _hoisted_62 = { class: "h-14 w-full bg-purple rounded-md mt-6 flex items-center" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("p", { class: "uppercase text-white text-sm sm:text-lg font-bold pl-2 flex-1" }, "Enter Contribution", -1)
const _hoisted_64 = { class: "flex justify-end flex-1 gap-x-2" }
const _hoisted_65 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_66 = { class: "mt-6" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-bold text-dark-blue" }, "My Story", -1)
const _hoisted_68 = { class: "mt-1.5" }
const _hoisted_69 = { class: "flex justify-end mt-10 pb-4 sm:pb-0" }
const _hoisted_70 = {
  key: 3,
  class: "min-h-screen flex flex-col"
}
const _hoisted_71 = /*#__PURE__*/_createElementVNode("h1", { class: "text-dark-blue text-3xl font-bold text-center mt-8 mb-5" }, "Checkout", -1)
const _hoisted_72 = { class: "max-w-7xl mx-auto px-4 space-y-10 pb-10 font-roboto flex-1 w-full" }
const _hoisted_73 = {
  key: 0,
  class: "grid grid-cols-1 gap-x-8 gap-y-8 pt-10 md:grid-cols-3"
}
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", { class: "px-4 sm:px-0" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-semibold leading-7 text-dark-blue" }, "Personal Information")
], -1)
const _hoisted_75 = { class: "grid grid-cols-1 gap-x-8 gap-y-8 pt-10 md:grid-cols-3" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "px-4 sm:px-0" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-semibold leading-7 text-dark-blue" }, "Summary")
], -1)
const _hoisted_77 = { class: "px-4 py-6 sm:p-8" }
const _hoisted_78 = { class: "grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 mx-auto" }
const _hoisted_79 = { class: "sm:col-span-full" }
const _hoisted_80 = { class: "flex justify-between" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("p", { class: "text-dark-blue" }, "Total Donation", -1)
const _hoisted_82 = { class: "text-dark-blue" }
const _hoisted_83 = { class: "flex justify-between mt-3" }
const _hoisted_84 = { class: "text-dark-blue" }
const _hoisted_85 = { class: "text-dark-blue" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("hr", { class: "w-full h-0.5 bg-gray-300 my-4" }, null, -1)
const _hoisted_87 = { class: "flex justify-between" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("p", { class: "text-dark-blue font-bold text-lg" }, "Total Payment", -1)
const _hoisted_89 = { class: "text-green font-bold text-lg" }
const _hoisted_90 = { class: "grid grid-cols-1 gap-x-8 gap-y-8 pt-10 md:grid-cols-3" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("div", { class: "px-4 sm:px-0" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-semibold leading-7 text-dark-blue" }, "Terms & Conditions of Receipt")
], -1)
const _hoisted_92 = { class: "bg-white shadow-md ring-1 ring-gray-900/5 rounded-xl md:col-span-2 mb-8" }
const _hoisted_93 = { class: "px-4 py-6 sm:p-8" }
const _hoisted_94 = { class: "grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 mx-auto" }
const _hoisted_95 = { class: "sm:col-span-full" }
const _hoisted_96 = { class: "text-dark-blue" }
const _hoisted_97 = { class: "flex" }
const _hoisted_98 = { class: "flex items-center me-4 mt-4" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("label", {
  for: "inline-radio",
  class: "ms-2 text-sm font-medium text-dark-blue"
}, "Yes", -1)
const _hoisted_100 = { class: "flex items-center me-4 mt-4" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("label", {
  for: "inline-2-radio",
  class: "ms-2 text-sm font-medium text-dark-blue"
}, "No", -1)
const _hoisted_102 = ["textContent"]
const _hoisted_103 = { class: "space-y-3" }
const _hoisted_104 = { class: "relative flex gap-x-3" }
const _hoisted_105 = { class: "flex h-6 items-center" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm leading-6" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "font-medium text-dark-blue" }, [
    /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('I accept the GetGo') + " "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "/docs/Privacy_Policy.pdf",
      class: "text-light-blue underline"
    }, /*#__PURE__*/_toDisplayString('Privacy Policy')),
    /*#__PURE__*/_createTextVNode(" " + /*#__PURE__*/_toDisplayString('and') + " "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "/docs/T&C.pdf",
      class: "text-light-blue underline"
    }, /*#__PURE__*/_toDisplayString('Terms and Conditions'))
  ])
], -1)
const _hoisted_107 = ["textContent"]
const _hoisted_108 = { class: "relative flex gap-x-3" }
const _hoisted_109 = { class: "flex h-6 items-center" }
const _hoisted_110 = { class: "text-sm leading-6" }
const _hoisted_111 = { class: "font-medium text-dark-blue" }
const _hoisted_112 = ["textContent"]
const _hoisted_113 = { class: "relative flex gap-x-3" }
const _hoisted_114 = { class: "flex h-6 items-center" }
const _hoisted_115 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm leading-6" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "font-medium text-dark-blue" }, /*#__PURE__*/_toDisplayString('Anonymous donation'))
], -1)
const _hoisted_116 = ["textContent"]
const _hoisted_117 = { class: "flex justify-center gap-x-10" }

import {onBeforeUnmount, onMounted, PropType, ref, watch} from 'vue';
import Footer from '@/components/Atomic/AQuarks/Footer.vue';
import Sidebar from '@/components/Layouts/Sidebar.vue';
import Button from '@/components/Atomic/AQuarks/Button.vue';
import SocialMediaShare from '@/components/Atomic/BAtoms/SocialMediaShare.vue';
import {useCampaignStore} from '@/areas/campaigns/stores/campaignStore'
import {useSchoolStore} from '@/areas/schools/stores/schoolStore'
import {CampaignDto} from '@/areas/campaigns/dtos/campaignDto';
import {SchoolDto} from '@/areas/schools/dtos/schoolDto'
import {AddDonationDto} from "@/areas/sessions/dtos/addDonationDto";
import {CampaignState} from "@/areas/campaigns/enums/campaignState";
import {useRoute, useRouter} from 'vue-router';
import {SchoolStateEnum} from '@/areas/schools/enums/schoolStateEnum'
import {formatAmount, formatDate} from "@/helpers/utilities/dataFormats";
import CampaignProgressBar from "@/components/Atomic/BAtoms/CampaignProgressBar.vue";
import SchoolSearch from "@/components/Atomic/BAtoms/SchoolSearch.vue";
import {UserDto} from "@/areas/users/dtos/userDto";
import NewUserForm from "@/areas/users/containers/NewUserForm.vue";
import keycloak from "@/keycloak";
import {useSessionStore} from "@/areas/sessions/stores/sessionStore";
import {CreateSessionDto} from "@/areas/sessions/dtos/createSessionDto";
import CampaignSearch from "@/components/Atomic/BAtoms/campaigns/CampaignSearch.vue";
import Tooltip from "@/components/Atomic/AQuarks/Tooltip.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DonateNow',
  props: {
  donationDto: {
    type: Object as PropType<AddDonationDto>,
    default: {
      amount: undefined,
      donationContributionPercentage: 7.5,
      isBonafideDonation: undefined,
      isAnonymous: false,
      marketingConsent: true,
    }
  },
  userDto: {
    type: Object as PropType<UserDto>,
    default: {
      firstName: '',
      lastName: '',
      email: '',
    }
  }
},
  setup(__props) {

const props = __props

// Prop refs
const donationDto = ref(props.donationDto)

const route = useRoute();
const router = useRouter()

// Stores
const schoolStore = useSchoolStore()
const campaignStore = useCampaignStore()
const sessionStore = useSessionStore()

// User
const userDto = ref(props.userDto)

// Schools
const schools = ref<SchoolDto[]>([]);
const filteredSchools = ref<SchoolDto[]>([]);

// Campaigns
const filteredCampaigns = ref<CampaignDto[]>([])

// Donation
const inCheckout = ref<boolean>(false)

// Checkout
const showBonafideTip = ref<boolean>(false)
const showAdminCostTip = ref<boolean>(false)

// Forms
const showFormErrors = ref<boolean>(false)
const hasUserError = ref<boolean>(!keycloak.authenticated)
const hasDonationError = ref<boolean>(true)

const bonafideError = ref<string>()
const termsError = ref<string>()
const marketingConsentError = ref<string>()
const anonymousError = ref<string>()
const isLoading = ref<boolean>(false)

const isShareModalVisible = ref<boolean>(false);
const pageTitle = ref<string>('Donate');
const pageDescription = ref<string>('You have the option to begin your search by selecting a school first or by directly searching for the campaign.');
const labelText = ref<string>('');
const showSearchInput = ref<string>('');
const selectedSchoolInfo = ref<string>('')
const campaignInput = ref<string>('')

const contributionAmountError = ref<string>('');

const effectiveCampaignContribution = ref<number>(0)
const effectiveAdminContribution = ref<number>(0)

watch(() => schoolStore.schools, (newValue) => {
  if (newValue) {
    schools.value = newValue
  }
}, {immediate: true})

watch(() => donationDto.value.acceptTerms, (newValue) => {
  if (newValue) {
    termsError.value = undefined
  }
})

watch(() => donationDto.value.isBonafideDonation, (newValue) => {
  if (undefined !== newValue) {
    bonafideError.value = undefined
  }
})

onBeforeUnmount(() => {
  schoolStore.$reset()
  campaignStore.$reset()
})

onMounted(async () => {
  isLoading.value = true

  if (keycloak.authenticated) {
    userDto.value = await keycloak.loadUserProfile() as UserDto
  }

  let argSchoolGuid = route.params.schoolGuid
  let argCampaignGuid = route.params.campaignGuid

  if (argSchoolGuid) {
    await schoolStore.schoolByGuid(argSchoolGuid as string)
    await campaignStore.init(argSchoolGuid as string, CampaignState.Active)

    if (argCampaignGuid) {
      await campaignStore.fetchCampaign(argSchoolGuid as string, argCampaignGuid as string)
    }

    isLoading.value = false

    return
  }

  await schoolStore.init([SchoolStateEnum.Approved])

  isLoading.value = false
})

const handleCheckout = async () => {
  if (!donationDto.value) {
    return contributionAmountError.value = 'Contribution amount is required';
  }
  if (!donationDto.value?.amount || donationDto.value.amount <= 0) {
    return contributionAmountError.value = 'Invalid contribution amount';
  }

  window.scrollTo(0, 0)

  if (!schoolStore.school || !campaignStore.campaign) {
    return
  }

  donationDto.value!.schoolGuid = schoolStore.school.guid!
  donationDto.value!.campaignGuid = campaignStore.campaign.guid

  inCheckout.value = true

  effectiveCampaignContribution.value = donationDto.value.amount * ((100 - donationDto.value!.donationContributionPercentage) / 100)
  effectiveAdminContribution.value = donationDto.value!.amount - effectiveCampaignContribution.value

  localStorage.setItem('postPaymentRedirectPath', `/donate/schools/${donationDto.value!.schoolGuid}/campaigns`);
}

const filterSchools = async (searchTerm: string) => {
  // Reset school select
  if (schoolStore.school) {
    //schoolStore.school = null
  }

  if (!schools.value) {
    return
  }
  filteredSchools.value = schools.value!.filter(school => school.name?.toLowerCase().includes(searchTerm.toLowerCase())).splice(0, 5)
}

const selectSchool = async (school: SchoolDto) => {
  isLoading.value = true

  await router.push({
    name: "Success", // Stay on the current route
    params: { schoolGuid: school.guid }, // Add or update the school GUID in the params
  });

  isLoading.value = false
}

const selectCampaign = async (campaign: CampaignDto) => {
  isLoading.value = true

  campaignInput.value = ''

  if (!campaign) {
    isLoading.value = false
    return
  }

  // campaignStore.campaign = campaign

  if (!schoolStore.school && campaign.school) {
    schoolStore.school = campaign.school
  }

  await router.push({
    name: "Failure", // Stay on the current route
    params: { schoolGuid: schoolStore.school!.guid!, campaignGuid: campaign.guid! }, // Add or update the school GUID in the params
  });

  window.scrollTo(0, 0)
};

const filterCampaigns = async (searchTerm: string) => {
  if (campaignStore.campaign) {
    campaignStore.campaign = null
  }

  if (searchTerm.trim() === '') {
    filteredCampaigns.value = campaignStore.campaigns ?? []
    return
  }

  let lowerCaseSearchTerm = searchTerm.toLowerCase()

  const campaignSearchResult = await campaignStore.fetchCampaignsByName(lowerCaseSearchTerm);

  if (campaignSearchResult.isSuccessful) {
    filteredCampaigns.value = campaignSearchResult.content! as CampaignDto[];
    return
  }
}

const getCoverPhotoLink = (campaign: CampaignDto) => {
  let coverPhotoAsset = campaign.campaignAssets.find(asset => asset.assetType === 'CoverPhoto');

  return coverPhotoAsset?.preSignedLink ? coverPhotoAsset!.preSignedLink : '/img/image.svg';
}

const changePage = (type: string) => {
  if (type === 'school') {
    pageTitle.value = 'Search School';
    labelText.value = 'Search School'
    pageDescription.value = 'You have the option to begin your search by selecting a school.';
    showSearchInput.value = 'school';
  } else {
    pageTitle.value = 'Search Campaign';
    labelText.value = 'Search Campaign'
    pageDescription.value = 'You have the option to begin your search by selecting a campaign.';
    showSearchInput.value = 'campaign';
  }
};

const handleCampaignDetailsBack = async () => {
  if (schoolStore.school) {
    const result = await schoolStore.schoolByGuid(schoolStore.school.guid!)

    if (result.isSuccessful) {
      await selectSchool(result.content! as SchoolDto)
    }

  }

  donationDto.value.amount = 0;
  await campaignStore.clearCampaign()
}

// Checkout 
const handleSubmit = async () => {
  showFormErrors.value = true

  validateDonation()

  // Validate donation
  if (bonafideError.value || marketingConsentError.value || anonymousError.value || termsError.value) {
    hasDonationError.value = true
    return
  }

  if (hasUserError.value) {
    window.scrollTo(0, 0)
    return
  }

  await createPaymentIntent()
}

const createPaymentIntent = async () => {
  const createSessionDto = {
    donation: donationDto.value,
    user: userDto.value
  } as CreateSessionDto

  const result = await sessionStore.createSession(createSessionDto)

  if (!result.isSuccessful) {
    // handle error
    return;
  }

  window.location.href = result.content!.payment.redirectUrl
}

const validateDonation = () => {
  bonafideError.value = donationDto.value.isBonafideDonation === undefined ? "Please select whether this is a bona fide donation." : undefined
  termsError.value = donationDto.value.acceptTerms !== true ? "Read and Accept to continue" : undefined
}

const cancelCheckout = () => {
  inCheckout.value = false;
  window.scrollTo(0, 0);
};

// Social Media
const toggleShareModal = () => {
  if (schoolStore.school && campaignStore.campaign) {
    const sharePath = `${process.env.VUE_APP_BASE_APP_URL}/donate/schools/${schoolStore.school.guid}/campaigns/${campaignStore.campaign.guid}`;
    localStorage.setItem('sharePath', sharePath);

    isShareModalVisible.value = !isShareModalVisible.value;
  }
};

return (_ctx: any,_cache: any) => {
  return (!isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(Sidebar),
        _createElementVNode("div", _hoisted_2, [
          (!_unref(schoolStore).school && !_unref(campaignStore).campaign)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h2", {
                    textContent: _toDisplayString(pageTitle.value),
                    class: "mx-auto max-w-2xl text-3xl font-bold tracking-tight text-dark-blue sm:text-4xl"
                  }, null, 8, _hoisted_5),
                  _createElementVNode("p", {
                    textContent: _toDisplayString(pageDescription.value),
                    class: "mx-auto mt-6 max-w-xl text-lg leading-8 text-dark-blue"
                  }, null, 8, _hoisted_6),
                  (showSearchInput.value === 'school')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("label", {
                            textContent: _toDisplayString(labelText.value),
                            class: "text-dark-blue mb-2"
                          }, null, 8, _hoisted_9),
                          _createVNode(SchoolSearch, {
                            style: 'mt-2 block rounded-md border-0 py-1.5 px-2 text-dark-blue shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:leading-6',
                            school: _unref(schoolStore).school === null ? undefined : _unref(schoolStore).school,
                            "filtered-schools": filteredSchools.value,
                            onSchoolChange: selectSchool,
                            onInput: _cache[0] || (_cache[0] = (newSchool) => filterSchools(newSchool))
                          }, null, 8, ["school", "filtered-schools"])
                        ])
                      ]))
                    : (showSearchInput.value === 'campaign')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("label", {
                                textContent: _toDisplayString(labelText.value),
                                class: "text-dark-blue mb-2"
                              }, null, 8, _hoisted_13),
                              _createVNode(CampaignSearch, {
                                style: 'mt-2 block rounded-md border-0 py-1.5 px-2 text-dark-blue shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:leading-6',
                                campaign: _unref(campaignStore).campaign === null ? undefined : _unref(campaignStore).campaign,
                                "filtered-campaigns": filteredCampaigns.value,
                                onCampaignChange: selectCampaign,
                                onInput: _cache[1] || (_cache[1] = (newValue) => filterCampaigns(newValue))
                              }, null, 8, ["campaign", "filtered-campaigns"])
                            ])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createVNode(Button, {
                            buttonText: 'Search Campaign',
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (changePage('campaign'))),
                            class: "text-white bg-light-blue font-roboto font-normal py-3 w-44 rounded-md shadow-md"
                          }),
                          _createVNode(Button, {
                            buttonText: 'Search School',
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (changePage('school'))),
                            class: "text-dark-blue bg-transparent border border-dark-blue font-roboto font-normal py-3 w-44 rounded-md shadow-md"
                          })
                        ]))
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(schoolStore).school && !_unref(campaignStore).campaign && _unref(campaignStore).campaigns )
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  (_unref(campaignStore).campaigns.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("label", {
                          textContent: _toDisplayString(labelText.value),
                          class: "text-dark-blue mb-2"
                        }, null, 8, _hoisted_19),
                        _createVNode(SchoolSearch, {
                          style: 'mt-2 block rounded-md border-0 py-1.5 px-2 text-dark-blue shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:leading-6',
                          school: _unref(schoolStore).school,
                          "filtered-schools": filteredSchools.value,
                          onSchoolChange: selectSchool,
                          onInput: _cache[4] || (_cache[4] = (newSchool) => filterSchools(newSchool))
                        }, null, 8, ["school", "filtered-schools"])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        (!isLoading.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_21, "No campaigns available yet."))
                          : _createCommentVNode("", true)
                      ])),
                  _createElementVNode("div", _hoisted_22, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(campaignStore).campaigns, (campaign) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: campaign.guid,
                        class: "group relative flex flex-col overflow-hidden rounded-xl border border-gray-200 bg-white shadow-md hover:scale-105 transition-transform duration-300 ease-in-out"
                      }, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("img", {
                            src: getCoverPhotoLink(campaign),
                            alt: "Campaign Cover Photo",
                            class: "h-full w-full object-cover object-center sm:h-full sm:w-full"
                          }, null, 8, _hoisted_24)
                        ]),
                        _createElementVNode("div", {
                          onClick: ($event: any) => (selectCampaign(campaign)),
                          class: "flex flex-1 flex-col space-y-2 p-4"
                        }, [
                          _createElementVNode("h3", _hoisted_26, [
                            _hoisted_27,
                            _createTextVNode(" " + _toDisplayString(campaign.displayName), 1)
                          ]),
                          _createVNode(CampaignProgressBar, {
                            "target-amount": campaign.targetAmount,
                            "cumulative-donations": campaign.cumulativeDonations
                          }, null, 8, ["target-amount", "cumulative-donations"]),
                          _createElementVNode("div", _hoisted_28, [
                            _hoisted_29,
                            _createElementVNode("p", _hoisted_30, _toDisplayString(_unref(formatDate)(campaign.endDate)), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _hoisted_31,
                            _createElementVNode("p", _hoisted_32, _toDisplayString(campaign.story), 1)
                          ])
                        ], 8, _hoisted_25)
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(campaignStore).campaign !== null && !inCheckout.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("a", {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (handleCampaignDetailsBack())),
                      class: "flex items-center cursor-pointer"
                    }, _hoisted_38)
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("img", {
                              src: getCoverPhotoLink(_unref(campaignStore).campaign),
                              alt: "Campaign Cover Photo",
                              class: "object-cover object-center w-full"
                            }, null, 8, _hoisted_44)
                          ])
                        ]),
                        (_unref(schoolStore).school)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                              _createElementVNode("h3", _hoisted_46, _toDisplayString(_unref(campaignStore).campaign.displayName), 1),
                              _createElementVNode("p", _hoisted_47, _toDisplayString(_unref(schoolStore).school!.name), 1),
                              _createElementVNode("p", _hoisted_48, _toDisplayString(_unref(schoolStore).school!.address.city) + ", " + _toDisplayString(_unref(schoolStore).school!.address.province), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("div", _hoisted_50, [
                            _createElementVNode("div", null, [
                              _hoisted_51,
                              _createElementVNode("p", _hoisted_52, _toDisplayString(_unref(formatDate)(_unref(campaignStore).campaign.startDate)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_53, [
                              _hoisted_54,
                              _createElementVNode("p", _hoisted_55, _toDisplayString(_unref(formatDate)(_unref(campaignStore).campaign.endDate)), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_56, [
                            _hoisted_57,
                            _createElementVNode("span", _hoisted_58, "R" + _toDisplayString(_unref(campaignStore).campaign !== null ? _unref(campaignStore).campaign.targetAmount : '-'), 1)
                          ]),
                          _createVNode(CampaignProgressBar, {
                            "target-amount": _unref(campaignStore).campaign.targetAmount,
                            "cumulative-donations": _unref(campaignStore).campaign.cumulativeDonations
                          }, null, 8, ["target-amount", "cumulative-donations"]),
                          _createElementVNode("div", { class: "h-14 w-full bg-dark-blue rounded-md mt-6 flex items-center" }, [
                            _hoisted_59,
                            _createElementVNode("div", { class: "flex justify-end flex-1 gap-x-2" }, [
                              _createElementVNode("a", {
                                onClick: toggleShareModal,
                                class: "bg-white mr-2.5 rounded-full text-dark-blue"
                              }, _hoisted_61)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_62, [
                            _hoisted_63,
                            _createElementVNode("div", _hoisted_64, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((donationDto.value.amount) = $event)),
                                type: "number",
                                placeholder: "Enter Amount",
                                class: "block w-full rounded-md border-0 py-1.5 px-2 text-dark-blue shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6 outline-none mr-2",
                                required: ""
                              }, null, 512), [
                                [_vModelText, donationDto.value.amount]
                              ])
                            ])
                          ]),
                          (contributionAmountError.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_65, _toDisplayString(contributionAmountError.value), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_66, [
                            _hoisted_67,
                            _createElementVNode("p", _hoisted_68, _toDisplayString(_unref(campaignStore).campaign.story), 1)
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_69, [
                    _createVNode(Button, {
                      onClick: handleCheckout,
                      buttonText: "Donate",
                      class: "bg-light-blue text-white py-2.5 w-72 rounded-md"
                    })
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (inCheckout.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                _hoisted_71,
                _createElementVNode("div", _hoisted_72, [
                  (!_ctx.$keycloak.authenticated)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                        _hoisted_74,
                        _createVNode(NewUserForm, {
                          onUpdate: _cache[7] || (_cache[7] = ($event: any) => (userDto.value = $event)),
                          onHasError: _cache[8] || (_cache[8] = ($event: any) => (hasUserError.value = $event)),
                          user: userDto.value!,
                          "show-errors": showFormErrors.value
                        }, null, 8, ["user", "show-errors"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_75, [
                    _hoisted_76,
                    _createElementVNode("form", {
                      onSubmit: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (hasUserError.value || hasDonationError.value), ["prevent"])),
                      class: "bg-white shadow-md ring-1 ring-gray-900/5 rounded-xl md:col-span-2"
                    }, [
                      _createElementVNode("div", _hoisted_77, [
                        _createElementVNode("div", _hoisted_78, [
                          _createElementVNode("div", _hoisted_79, [
                            _createElementVNode("div", _hoisted_80, [
                              _hoisted_81,
                              _createElementVNode("p", _hoisted_82, "R " + _toDisplayString(_unref(formatAmount)(effectiveCampaignContribution.value)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_83, [
                              _createElementVNode("div", _hoisted_84, [
                                _createTextVNode("Admin Cost "),
                                _createVNode(Tooltip, { content: "The GetGo deducts a 7.5% administration cost from the donation amount. This helps us maintain our platform and provide our services to you and our campaigners." })
                              ]),
                              _createElementVNode("p", _hoisted_85, "R " + _toDisplayString(_unref(formatAmount)(effectiveAdminContribution.value)), 1)
                            ]),
                            _hoisted_86,
                            _createElementVNode("div", _hoisted_87, [
                              _hoisted_88,
                              _createElementVNode("p", _hoisted_89, "R " + _toDisplayString(_unref(formatAmount)(donationDto.value.amount)), 1)
                            ])
                          ])
                        ])
                      ])
                    ], 32)
                  ]),
                  _createElementVNode("div", _hoisted_90, [
                    _hoisted_91,
                    _createElementVNode("form", _hoisted_92, [
                      _createElementVNode("div", _hoisted_93, [
                        _createElementVNode("div", _hoisted_94, [
                          _createElementVNode("div", _hoisted_95, [
                            _createElementVNode("div", _hoisted_96, [
                              _createTextVNode("This is a bona fide donation? * "),
                              _createVNode(Tooltip, { content: "A bona fide donation is one that is made in good faith and sincerity. If the recipient of your donation is a relative, connected person, or employee of your company, the donation does not qualify for a Section 18A tax certificate." })
                            ]),
                            _createElementVNode("div", _hoisted_97, [
                              _createElementVNode("div", _hoisted_98, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((donationDto.value.isBonafideDonation) = $event)),
                                  id: "inline-radio",
                                  type: "radio",
                                  value: true,
                                  name: "inline-radio-group",
                                  class: "w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:border-gray-600"
                                }, null, 512), [
                                  [_vModelRadio, donationDto.value.isBonafideDonation]
                                ]),
                                _hoisted_99
                              ]),
                              _createElementVNode("div", _hoisted_100, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((donationDto.value.isBonafideDonation) = $event)),
                                  id: "inline-2-radio",
                                  type: "radio",
                                  value: false,
                                  name: "inline-radio-group",
                                  class: "w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:border-gray-600"
                                }, null, 512), [
                                  [_vModelRadio, donationDto.value.isBonafideDonation]
                                ]),
                                _hoisted_101
                              ])
                            ]),
                            (showFormErrors.value && bonafideError.value)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: "text-red-500 text-sm mt-1",
                                  textContent: _toDisplayString(bonafideError.value)
                                }, null, 8, _hoisted_102))
                              : _createCommentVNode("", true),
                            _createElementVNode("fieldset", {
                              onSubmit: _cache[15] || (_cache[15] = _withModifiers(() => hasDonationError.value, ["prevent"])),
                              class: "col-span-full mt-8"
                            }, [
                              _createElementVNode("div", _hoisted_103, [
                                _createElementVNode("div", _hoisted_104, [
                                  _createElementVNode("div", _hoisted_105, [
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((donationDto.value.acceptTerms) = $event)),
                                      type: "checkbox",
                                      class: "h-4 w-4 rounded border-gray-300"
                                    }, null, 512), [
                                      [_vModelCheckbox, donationDto.value.acceptTerms]
                                    ])
                                  ]),
                                  _hoisted_106
                                ]),
                                (showFormErrors.value && termsError.value)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: "text-red-500 text-sm mt-1",
                                      textContent: _toDisplayString(termsError.value)
                                    }, null, 8, _hoisted_107))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_108, [
                                  _createElementVNode("div", _hoisted_109, [
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((donationDto.value.marketingConsent) = $event)),
                                      type: "checkbox",
                                      class: "h-4 w-4 rounded border-gray-300"
                                    }, null, 512), [
                                      [_vModelCheckbox, donationDto.value.marketingConsent]
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_110, [
                                    _createElementVNode("label", _hoisted_111, _toDisplayString('I agree to receive marketing communications from GetGo.'), 1)
                                  ])
                                ]),
                                (showFormErrors.value && marketingConsentError.value)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 1,
                                      class: "text-red-500 text-sm mt-1",
                                      textContent: _toDisplayString(marketingConsentError.value)
                                    }, null, 8, _hoisted_112))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_113, [
                                  _createElementVNode("div", _hoisted_114, [
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((donationDto.value.isAnonymous) = $event)),
                                      type: "checkbox",
                                      class: "h-4 w-4 rounded border-gray-300"
                                    }, null, 512), [
                                      [_vModelCheckbox, donationDto.value.isAnonymous]
                                    ])
                                  ]),
                                  _hoisted_115
                                ]),
                                (showFormErrors.value && anonymousError.value)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 2,
                                      class: "text-red-500 text-sm mt-1",
                                      textContent: _toDisplayString(anonymousError.value)
                                    }, null, 8, _hoisted_116))
                                  : _createCommentVNode("", true)
                              ])
                            ], 32)
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_117, [
                    _createVNode(Button, {
                      buttonText: "Cancel",
                      onClick: cancelCheckout,
                      class: "text-dark-blue bg-transparent border border-dark-blue rounded-md py-2 w-72"
                    }),
                    _createVNode(Button, {
                      buttonText: "Donate",
                      onClick: handleSubmit,
                      class: "text-white bg-light-blue rounded-md py-2 w-72"
                    })
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(SocialMediaShare, {
            isVisible: isShareModalVisible.value,
            "onClick:isVisible": _cache[16] || (_cache[16] = ($event: any) => (isShareModalVisible.value = $event))
          }, null, 8, ["isVisible"])
        ]),
        _createVNode(Footer)
      ]))
    : _createCommentVNode("", true)
}
}

})